import Switch from './Switch';
import Action from './Action';
import Date from './Date';

export default {
  Switch,
  Action,
  Date,
};
